window.addEventListener("DOMContentLoaded", (event) => {

  const windowHeight = Array.from(document.querySelectorAll(".window-height"));
  const updateWindowHeight = () => {
    if (windowHeight) {
      windowHeight.forEach((el) => {
        el.style.height = `${window.innerHeight}px`;
        // console.log(el);
      });
    }
    
  };
  updateWindowHeight();
  window.addEventListener("resize", function (event) {
    updateWindowHeight();
  });



});
